import React from 'react';
import styled from 'styled-components';
import { Grid } from 'ui-toolkit';

export interface ILoginPageContainerProps {}
const HeightContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
const GridContainer = styled(Grid)`
  justify-items: center;
`;
const GridFiller = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const LoginPageContainer: React.FC<React.PropsWithChildren<ILoginPageContainerProps>> = ({ children }) => {
  return (
    <HeightContainer>
      <GridFiller>
        <div>
          <GridContainer alignItems="center" columnCount={1}>
            {children}
          </GridContainer>
        </div>
      </GridFiller>
    </HeightContainer>
  );
};
